import React, {FC, useEffect} from 'react';
import './ModalProposalStatusEdit.scss';
import {StatusManualProposalModel} from "../../../models/ProposalsTrack/StatusManualProposalModel";
import ModalDefault from "../../ModalDefault/ModalDefault";
import ErrorMessage from "../../ErrorMessage/ErrorMessage";
import {toast} from "react-toastify";
import {useProposalsStatus} from "../../../providers/ProposalsCovenantsTable/ProposalManualStatusProvider";
import {useForm} from "react-hook-form";

interface ModalProposalStatusEditProps {
    show: boolean;
    isLoading: boolean;
    onClose: any;
    item?: StatusManualProposalModel | null;
}

type FormValues = {
    id: number | null;
    description: string;
    backgroundColor: string;
    textColor: string;

}
const ModalProposalStatusEdit: FC<ModalProposalStatusEditProps> = ({onClose, show, item, isLoading,}) => {
    const {register, setValue, getValues, handleSubmit, formState: {errors}} = useForm<FormValues>();
    const {handleList, handleSave} = useProposalsStatus()


    useEffect(() => {
        if (item) {
            setValue("description", item.description ?? "");
            setValue("textColor", item.textColor ?? "#FFFFFF");
            setValue("backgroundColor", item.backgroundColor ?? "#000000");
            setValue("id", item.id ?? 0);
        }
    }, [item, show])


    useEffect(() => {
        if (!show) {
            setValue("description", "");
            setValue("textColor", "#FFFFFF");
            setValue("backgroundColor", "#000000");
            setValue("id", null);
        }
    }, [show])
    const onSubmit = async (data: FormValues) => {
        const res = await handleSave(data);
        if (!res) {
            handleList().then();
            toast.success("Salvo com sucesso");
            onClose();
            return;
        }

        toast.error(res);
    }

    return (
        <ModalDefault
            title={!!item ? "Alterar status da proposta" : "Adicionar status da proposta"}
            show={show}
            onClose={onClose}
            handleSubmit={handleSubmit(onSubmit)}
            disabledSubmit={isLoading}
            showButtonSpinner={isLoading}
            buttonText={isLoading ? "Salvando..." : "Salvar"}
        >
            <div className="ModalProposalStatusEdit" data-testid="ModalProposalStatusEdit">

                <div className="col-12 col-md-12 form-group">
                    <div className='row'>
                        <div className='col-12 col-md-6 form-group'>
                            <label>Descrição</label>
                            <input
                                {...register("description", {required: true, maxLength: 25, minLength: 2})}
                                maxLength={25}
                                minLength={2}
                                className='form-control'
                                type='text'
                            />
                            <ErrorMessage name="Descrição" type={errors?.description?.type} max={25} min={2}/>
                        </div>

                        <div className='col-12 col-md-6'>
                            <div className='row'>
                                <div className='col-6 form-group'>
                                    <label>Cor do fundo</label>
                                    <input
                                        className='form-control form-control-color'
                                        type='color'
                                        {...register('backgroundColor')}
                                        // style={{width: '100%'}}
                                    />
                                </div>
                                <div className='col-6 form-group'>
                                    <label>Cor do texto</label>
                                    <input
                                        className='form-control form-control-color'
                                        type='color'
                                        {...register('textColor')}
                                        ///style={{width: '100%'}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </ModalDefault>
    )

};

export default ModalProposalStatusEdit;
